import React from "react";

export const name_tool = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <g
            id="Group_20"
            data-name="Group 20"
            transform="translate(-1608.527 792)"
        >
            <g id="g4771" transform="translate(1575.104 -793.123)">
                <path
                    id="path3597"
                    d="M33.424,3.243l7.88,7.88L33.424,19l2.12,2.12,10-10-10-10Z"
                />
                <rect
                    id="rect4168"
                    width="11.465"
                    height="2.649"
                    transform="translate(46.057 18.473)"
                />
            </g>
        </g>
    </svg>
);
